import { Link, Stack, Text } from '@scality/core-ui';
import { Button } from '@scality/core-ui/dist/next';
import styled from 'styled-components';
import { useAuthPopup } from '../hooks/useAuthPopup';
import { XXLargeGradientText } from './TextVariants';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  gap: 16px;
`;

export function IframeLoginPage() {
  const { login } = useAuthPopup();

  return (
    <Container>
      <Stack direction="vertical" gap="r16">
        <XXLargeGradientText>Welcome to Guardian</XXLargeGradientText>
        <Text variant="Large" color="textSecondary">
          Guardian is an AI agent integrated in your deployment.
        </Text>
        <Button
          onClick={login}
          label="Sign in with Scality Account"
          variant="primary"
        />
        <Text color="textSecondary">
          No account? Contact your administrator.<br />
          Need help?{' '}
          <Link href="mailto:support@scality.com">support@scality.com</Link>.
        </Text>
      </Stack>
    </Container>
  );
}
